export default {
  state: {
    list: [
      { label: "English", value: "en" },
      { label: "French", value: "fr" },
      { label: "Swahili", value: "sw" },
      { label: "Hindi", value: "in" },
      { label: "Marathi", value: "mr" },
      { label: "Gujarati", value: "gu" },
      { label: "Russian", value: "ru" },
      { label: "Kazakh", value: "kk" },
      { label: "Tajiki", value: "tg" },
      { label: "Nepali", value: "ne" },
      { label: "Kyrgyz", value: "ky" },
      { label: "Urdu", value: "ur" },
      { label: "Sindhi", value: "sd" },
      { label: "Telugu", value: "te" },
      { label: "Twi", value: "tw" },
      { label: "Vietnamese", value: "vi" },
      { label: "Amharic", value: "am" },
    ],
  },
  mutations: {},
  actions: {},
  getters: {
    getLangOptions: (state) => {
      return state.list;
    },
  },
};
